import React from 'react';
import imgLoader from './../../assets/images/wrongpass-page-login.png';
import './../../assets/styles/Error404.css';

const Error404 = (props) => {
	if (props.appState !== 'error404') {
		return null;
	}

	let locationUrl = window.location.host;
	if (locationUrl.indexOf('http') < 0) {
		// for 'localhost' case example
		locationUrl = `http://${window.location.host}`;
	}

	setTimeout(() => {
		window.location.replace(locationUrl);
	}, 2500);

	window.document.getElementById('App').style.backgroundColor = '#434342';

	return (
		<div className="error404_container">
			<img src={imgLoader} alt={'Reiniciando...'} />
		</div>
	);
};

export default Error404;
